/**
 * 通用js方法封装处理
 * Copyright (c) 2022 youngbook
 */

// 日期格式化
export function parseTime(time, pattern) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        } else if (typeof time === 'string') {
            time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}

// 表单重置
export function resetForm(refName) {
    if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
    }
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
    let search = params;
    search.params = typeof (search.params) === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
    dateRange = Array.isArray(dateRange) ? dateRange : [];
    if (typeof (propName) === 'undefined') {
        search.params['beginTime'] = dateRange[0];
        search.params['endTime'] = dateRange[1];
    } else {
        search.params['begin' + propName] = dateRange[0];
        search.params['end' + propName] = dateRange[1];
    }
    return search;
}

// 回显数据字典
export function selectDictLabel(datas, value) {
    var actions = [];
    Object.keys(datas).some((key) => {
        if (datas[key].value == ('' + value)) {
            actions.push(datas[key].label);
            return true;
        }
    })
    return actions.join('');
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
    var actions = [];
    var currentSeparator = undefined === separator ? "," : separator;
    var temp = value.split(currentSeparator);
    Object.keys(value.split(currentSeparator)).some((val) => {
        Object.keys(datas).some((key) => {
            if (datas[key].value == ('' + temp[val])) {
                actions.push(datas[key].label + currentSeparator);
            }
        })
    })
    return actions.join('').substring(0, actions.join('').length - 1);
}

// 字符串格式化(%s )
export function sprintf(str) {
    var args = arguments, flag = true, i = 1;
    str = str.replace(/%s/g, function () {
        var arg = args[i++];
        if (typeof arg === 'undefined') {
            flag = false;
            return '';
        }
        return arg;
    });
    return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
    if (!str || str == "undefined" || str == "null") {
        return "";
    }
    return str;
}

// 数据合并
export function mergeRecursive(source, target) {
    for (var p in target) {
        try {
            if (target[p].constructor == Object) {
                source[p] = mergeRecursive(source[p], target[p]);
            } else {
                source[p] = target[p];
            }
        } catch (e) {
            source[p] = target[p];
        }
    }
    return source;
};

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
    let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children'
    };

    var childrenListMap = {};
    var nodeIds = {};
    var tree = [];

    for (let d of data) {
        let parentId = d[config.parentId];
        if (childrenListMap[parentId] == null) {
            childrenListMap[parentId] = [];
        }
        nodeIds[d[config.id]] = d;
        childrenListMap[parentId].push(d);
    }

    for (let d of data) {
        let parentId = d[config.parentId];
        if (nodeIds[parentId] == null) {
            tree.push(d);
        }
    }

    for (let t of tree) {
        adaptToChildrenList(t);
    }

    function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
            o[config.childrenList] = childrenListMap[o[config.id]];
        }
        if (o[config.childrenList]) {
            for (let c of o[config.childrenList]) {
                adaptToChildrenList(c);
            }
        }
    }

    return tree;
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
    let result = ''
    for (const propName of Object.keys(params)) {
        const value = params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof (value) !== "undefined") {
            if (typeof value === 'object') {
                for (const key of Object.keys(value)) {
                    if (value[key] !== null && typeof (value[key]) !== 'undefined') {
                        let params = propName + '[' + key + ']';
                        var subPart = encodeURIComponent(params) + "=";
                        result += subPart + encodeURIComponent(value[key]) + "&";
                    }
                }
            } else {
                result += part + encodeURIComponent(value) + "&";
            }
        }
    }
    return result
}

// 验证是否为blob格式
export async function blobValidate(data) {
    try {
        const text = await data.text();
        JSON.parse(text);
        return false;
    } catch (error) {
        return true;
    }
}

// 将数字转换为两位小数
export function parseMoneyFormat(num) {
    let result = (!isNaN(num) && num !== undefined && num != null) ?
        Number(num).toFixed(3) : '0.000';
    return result.substring(0, result.length - 1);
}

/**
 * 计算列的宽度
 *
 * @param tableRef 表格的ref对象
 * @param addWidth 添加宽度 用于可能含有其他自定义的元素宽度
 * @param columnName 列头部显示的值
 * @param columnKeys 列显示的字段key数组
 */
export function calcColumnWidth(tableRef, addWidth, columnName, columnKeys) {

    //this.$nextTick(() => { do });

    //获取字体大小
    let fontSize = getStyleByRef(tableRef, "font-size", 14);
    //获取盒子左右的填充宽度
    let left = getStyleByRef(tableRef, "padding-left", 10);
    let right = getStyleByRef(tableRef, "padding-right", 10);

    let maxColumnValue = (columnName === undefined || columnName === null) ? "" : columnName;

    let result = calcContentLength(maxColumnValue, fontSize);

    for (let j = 0; j < columnKeys.length; j++) {
        for (let i = 0; i < tableRef.data.length; i++) {
            if (tableRef.data[i][columnKeys[j]] === undefined || tableRef.data[i][columnKeys[j]] === null) {
                continue;
            }
            let temp = calcContentLength(tableRef.data[i][columnKeys[j]] + "", fontSize);
            if (result < temp) {
                result = temp;
            }
        }
    }

    return result + left + right + addWidth + "px";
}

/**
 * 计算指定内容的长度
 *
 * @param content 指定内容
 * @param fontSize 字体大小
 */
export function calcContentLength(content, fontSize) {
    let result = 0;
    if (content === null || content === undefined) {
        return result;
    }

    if (fontSize === null || fontSize === undefined || fontSize <= 0) {
        fontSize = 14;
    }

    for (const char of content) {
        if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z') || (char >= '0' && char <= '9')) {
            // 如果是英文字符或者数字，为字符分配 {fontSize}*8/14 个单位宽度
            result += Math.ceil(fontSize * 8 / 14)
        } else if (char >= '\u4e00' && char <= '\u9fa5') {
            // 如果是中文字符，为字符分配 {fontSize} 个单位宽度
            result += fontSize;
        } else {
            // 其他种类字符，为字符分配 {fontSize}*10/14 个单位宽度
            result += Math.ceil(fontSize * 10 / 14);
        }
    }

    return result;
}

/**
 * 获取元素Ref指定的Style属性
 * * * 如果找不到就会向上(父组件)寻找, 直到结束 如果结束都没有找到 就返回 空字符串
 *
 * @param eleRef 元素Ref
 * @param attr 属性
 * @param defaultValue 找不到的默认值
 */
export function getStyleByRef(eleRef, attr, defaultValue) {
    if (eleRef === undefined || eleRef === null) {
        return defaultValue;
    }

    let value = eleRef.$el.style.getPropertyValue(attr);

    if (value === undefined || value === null || value === '') {
        return getStyleByRef(eleRef.$parent, attr, defaultValue);
    } else {
        return parseInt(value);
    }
}

/**
 * 判断当前字符串是否为日期字符串
 * @param str 判断字符
 */
export function isDateStr(str) {
    if (isNaN(str) && !isNaN(Date.parse(str))) {
        console.log(str)
        return true;
    }
    return false;
}

/**
 * 如果obj为null 就返回 replaceStr
 * @param obj Obj
 * @param replaceStr Null替换值
 */
export function ifNull(obj, replaceStr) {
    return obj ? obj : replaceStr;
}
